import React from "react";
import "./AboutOvest.css";
import logo from "../../../assets/ovest logo.svg";
import facebook from "../../../assets/facebook.svg";
import twitter from "../../../assets/twitter.svg";
import instagram from "../../../assets/instagram.svg";

const AboutOvest = () => {
  return (
    <div className="about-section">
      <div className="about-header">
        <h1>About OVest</h1>
      </div>
      <div className="About-logo">
        <div className="about-logo">
          <img src={logo} alt="" />
        </div>
      </div>

      <div className="about-text">
        <p
          style={{
            marginTop: "23px",
          }}
        >
          OVest (OSOURCE VESTMENT LTD) is a product of OSource Empire Limited.
          OVest was established with the Mission is to help individuals,
          organization and communities achieve financial security, build wealth
          and realize their dreams.
        </p>
        <p>
          OVest is a registered and thriving Investment and Funds Management
          Company managed by a team of experienced and competent professionals
          in the business of Foreign Exchange Trading, Crypto Market,
          Agriculture, Real Estate, Small Businesses and other investment
          opportunities offered by the industry.
        </p>
        <p>
          Our platform enables you to plan, save and invest money easily.
          Allowing you to easily build your savings and investment portfolios,
          manage your money securely and build a better financial future.
        </p>
      </div>
      <div className="about-social">
        <p>Join the coversation on our social media handles</p>
        <div className="about-icon">
          <a href="https://www.facebook.com/OVestOfficial/" target="blank">
            <img src={facebook} alt="facebook" className="ml-3" />
          </a>
          <a
            href="
         https://twitter.com/OVestOfficial
          "
            target="blank"
          >
            <img src={twitter} alt="twitter" className="social-icon" />
          </a>
          <a
            href="
          https://www.instagram.com/OVestOfficial/
          "
            target="blank"
          >
            <img src={instagram} alt="instagram" className="social-icon" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default AboutOvest;
